import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { Milestone } from '@/components/PaymentRequest/types'

export const useMilestoneStore = defineStore('milestone', () => {
  const milestones = ref<Milestone[]>([])
  const selectedMilestoneId = ref<string | null>(null)
  const error = ref<Error | null>(null)

  const selectedMilestone = computed(() =>
    milestones.value.find((m) => m.id === selectedMilestoneId.value),
  )

  const selectMilestone = (id: string | null) => {
    selectedMilestoneId.value = id
  }

  const reset = () => {
    milestones.value = []
    selectedMilestoneId.value = null
    error.value = null
  }

  return {
    milestones,
    selectedMilestoneId,
    selectedMilestone,
    error,
    selectMilestone,
    reset,
  }
})
